/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { AppUtilityService } from './../../core/services/app-utility.service';
import { BaseResponse } from './../../core/model/base-response.model';
import { BreTransferAreaDetails } from './../../core/model/bre-transfer-area-details.model';
import { ConfigService } from './../../core/services/config.service';
import { DataStoreService } from './../../core/services/datastore.service';
import { EditModeService } from '../../core/services/edit-mode.service';
import { LmsBaseAppComponent } from '../../core/component/base-app/lms-base-app.component';
import { LmsException } from './../../core/model/lms-exception.model';
import { LmsLoaderService } from './../../core/services/lms-loader.service';
import { LmsMenuService } from '../../core/services/lms-menu.service';
import { LmsModuleService } from '../../core/services/lms-module.service';
import { LocoDetail } from './../../core/model/loco-detail.model';
import { LocoIncidentService } from '../../core/services/loco-incident-service';
import { LocoStatusService } from './../../loco-status/shared/services/loco-status.service';
import { LocoTransfer } from './../../core/model/loco-transfer.model';
import { MessageDetails } from './../../core/model/message-details.model';
import { MessageHandlerService } from './../../core/services/message-handler.service';
import { PopupService } from '../../core/services/popup.service';
import { RouteChangePopupService } from '../../core/services/route-change-popup.service';
import { SelectItem } from 'primeng/api/selectitem';
import { StaticDataStoreService } from './../../core/services/static-datastore.service';
import { TabData } from './../../core/model/tab-data.model';
import { TabService } from '../../core/services/tab.service';
import { TerminalRoad } from './../../core/model/terminal-road-model';
import { UtilService } from '../../core/services/util.service';
import { PermitAll } from '@csx/security';
import { UserService } from '../../core/services/user.service';

/**
 * @export
 * @class LocoStatusComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-loco-status-data',
  templateUrl: './loco-status-data.component.html',
  styleUrls: ['./loco-status-data.component.scss']
})
@PermitAll()
export class LocoStatusDataComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {

  lastRefreshTime: string;
  locoStatusArr: Array<LocoDetail>;
  isSelectedLocos: boolean;
  isShowCancelLocoPlan: boolean;
  filteredLocoStatusArr: Array<LocoDetail>;
  selectedLocoStatusArr: Array<LocoDetail> = [];
  selectedLoco: LocoDetail;
  selectedLocoId: string;

  planLocomotive: boolean;
  setCurrentAssignment: boolean;
  planOrSetCurrentAssignment: boolean;
  cancelPlanLocomotive: boolean;
  popUpErrorMessage: string;
  selectedPlan = 'Train';
  transferResponse: BaseResponse;
  tabStoreSubscription: any;
  isValidThpSelection = false;

  planOption: Array<Object> = [
    { label: 'Train', value: 'Train' },
    { label: 'Terminal', value: 'Terminal' },
    { label: 'Foreign Railroad', value: 'Foreign Railroad' }
  ];

  thpPlanLoco = 'S';
  isAddTrainError: boolean;
  searchPlanTextTerminalError: boolean;
  selectedTerminalRoadError: boolean;
  confirmAction: string;
  confirmMessage: string;

  mileposts: Array<string> = [];
  mnemonics: Array<string> = [];
  filteredResults: Array<string> = [];
  roadValues: Array<TerminalRoad> = [];
  selectedTerminalRoad: string;
  selectedRoadValues: SelectItem[];
  filteredRoadValuesObj: SelectItem[];
  planTrainId: string;
  searchPlanTextTerminal: string;

  configData: any;
  errorDialog: Boolean = false;

  ruleException = false;
  isRuleExceptionSubmitEnabled: boolean;
  lmsExceptionList: Array<LmsException> = [];
  popUpServiceSubscription: any;
  commonopsPicklist: any;
  tabLevel: number;
  filteredTabs = [];

  /**
   * Creates an instance of LocoStatusComponent.
   * @param {LmsLoaderService} lmsLoaderService
   * @memberOf LocoStatusComponent
   */
  constructor(private lmsLoaderService: LmsLoaderService,
    private locoStatusService: LocoStatusService,
    private appUtilityService: AppUtilityService,
    configService: ConfigService,
    lmsMenuService: LmsMenuService,
    lmsModuleService: LmsModuleService,
    utilService: UtilService,
    editModeService: EditModeService,
    routeChangePopupService: RouteChangePopupService,
    private staticDataStoreService: StaticDataStoreService,
    popupService: PopupService,
    private messageHandlerService: MessageHandlerService,
    private dataStoreService: DataStoreService,
    private activateRoute: ActivatedRoute,
    private tabService: TabService,
    private locoIncidentService: LocoIncidentService, 
    public user: UserService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routeChangePopupService, popupService);
    this.type = 'Locomotive-Status';
    this.service = this.locoStatusService;
    this.popUpServiceSubscription = this.popupService.successObservable.subscribe((data) => {
      if (data && (data.action && data.action === true)) {
        this.checkSuccessOperation(data.message);
      }
    });
    this.popUpServiceSubscription = this.popupService.popupOprObservable.subscribe((data) => {
      if (data && (data.operation === 'allocateSuccess' || data.operation === 'deallocateSuccess')) {
        this.checkSuccessOperation(data.message);
      } else if (data && (data.operation === 'deAllocateError' || data.operation === 'allocateLocoError') && this.selectedTab && this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail) {
        this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].message = data.message;
      }
    });
    this.tabStoreSubscription = this.tabService.tabStoreObservable.subscribe(data => {
      if (data) {
        const selectedTab = data.find((tab) => { return tab.selected; });
        if (selectedTab) {
          this.filteredTabs = data.filter((tab) => { return selectedTab.type === tab.type; });
        }
      }
    });
    this.tabLevel = this.configService.getConfigData().tabIndex.dialogBox;
  }

  filterSelectedTerminalRoad(event) {
    // this.filteredRoadValuesObj = []
    // for (let i = 0; i < this.selectedRoadValues.length; i++) {
    //   let selectedRoad = this.selectedRoadValues[i];
    //   if (selectedRoad.value.toLowerCase().indexOf(event.query.toLowerCase()) == 0) {
    //     this.filteredRoadValuesObj.push(selectedRoad);
    //   }
    // }
  }

  checkIfTerminalValid() {
    return this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal);
  }

  setTabIndex(event) {
    if (event.keyCode == 9 && event.shiftKey) {
      event.preventDefault();
      if (document.getElementById('planSubmitPopup')) {
        document.getElementById('planSubmitPopup').focus();
      }
    }
  }

  tabOnSubmit(event) {
    event.preventDefault();
    if (event.keyCode == 9 && event.shiftKey) {
      if (document.getElementById('planCancelPopup')) {
        document.getElementById('planCancelPopup').focus();
      }
    } else {
      document.getElementById('currentAsignDropDown').focus();
    }
  }

  onSelectTerminalRoad(value) {
    if (value !== undefined) {
      this.selectedTerminalRoad = value.value;
    }
  }



  terminalRoadModelValueChange(event) {
    if (event.target.value == '') {
      this.filteredRoadValuesObj = this.selectedRoadValues;
    } else {
      this.filteredRoadValuesObj = this.selectedRoadValues.filter(item =>  {
        return item.value.toLowerCase().startsWith(event.target.value.toLowerCase());
      });
    }
  }

  onFocusTerminalRoad(event, autoComplete) {
    if (event.target.value == '') {
      this.filteredRoadValuesObj = [];
      this.filteredRoadValuesObj = this.selectedRoadValues;
      // autoComplete.show();
    } else {
      this.filteredRoadValuesObj = this.selectedRoadValues.filter(item =>  {
        return item.value.toLowerCase().startsWith(event.target.value.toLowerCase());
      });
    }
    if (this.filteredRoadValuesObj.length) {
      autoComplete.show();
    }
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LocoStatusComponent
   */
  ngOnInit() {
    super.init(this.search);
    let loadedLocoStatusArr = [];
    this.locoStatusArr = [];
    this.lmsLoaderService.hideLoader();
    if (this.selectedTab) {
      if (this.dataStoreService.getValue(this.selectedTab)) {
        const arr: any = [];
        const length = Array<LocoDetail>(this.dataStoreService.getValue(this.selectedTab).data.Data).length;
        for (let i = 0; i < length; i++) {
          arr.push(Array<LocoDetail>(this.dataStoreService.getValue(this.selectedTab).data.Data)[i]);
        }
        if (arr && arr[0]) {
          this.locoStatusArr = arr[0].locoStatusArr;
          this.lastRefreshTime = arr[0].lastRefreshTime;
        }
      } else {
        const loco = {
          searcheLocomotiveIdentifier: this.selectedTab.tabSearchParameter.searchText,
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(this.selectedTab.tabSearchParameter.searchText)
        };
        this.locoStatusArr.push(loco);
        this.loadDataFromService(false, '', loco);
      }
    }
    if (!this.locoStatusArr) {
      this.locoStatusArr = [];
    } else {
      loadedLocoStatusArr = this.locoStatusArr.filter((locoStatus) => {
        return locoStatus.isLocoStatusLoaded;
      });
    }
    if (this.locoStatusArr && (this.locoStatusArr.length === 0) || (loadedLocoStatusArr && loadedLocoStatusArr.length === this.locoStatusArr.length)) {
      this.locoStatusArr.push({});
    }

    this.configData = this.configService.getConfigData();
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (this.commonopsPicklist && this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.interchangeList &&
      this.commonopsPicklist.masterData.interchangeList.length > 0) {
      for (let i = 0; i < this.commonopsPicklist.masterData.interchangeList.length; i++) {
        const terminalRoad: TerminalRoad = this.commonopsPicklist.masterData.interchangeList[i];
        this.roadValues.push(terminalRoad);
      }
    }
  }

  /**
   * Loco selection event triggered.
   * @memberOf LocoStatusComponent
   */
  public locoSelecttionEVent() {
    if (this.locoStatusArr) {
      const locoStatusArr = _.filter(this.locoStatusArr, function (locoStatus) {
        return locoStatus.isLocoSelected;
      });
      const cancelLocoStatusArr = [];
      for (let i = 0; i < this.locoStatusArr.length; i++) {
        if (this.locoStatusArr[i] && this.locoStatusArr[i].isLocoSelected && this.appUtilityService.isPlannedLoco(this.locoStatusArr[i])) {
          cancelLocoStatusArr.push(this.locoStatusArr[i]);
        }
      }
      if (locoStatusArr && locoStatusArr.length > 0) {
        this.isSelectedLocos = true;
      } else {
        this.isSelectedLocos = false;
      }
      if (cancelLocoStatusArr && cancelLocoStatusArr.length > 0) {
        this.isShowCancelLocoPlan = true;
      } else {
        this.isShowCancelLocoPlan = false;
      }
    }
  }

  /**
   * Invoked when double enter triggred.
   * @param {any} event
   * @memberOf LocoStatusDataComponent
   */
  public doubleEnterEvent(event) {
    this.lmsLoaderService.showLoader();
    if (event) {
      this.locoStatusArr = event;
      this.loadDataFromService(true);
    }
  }

  /**
   * Invoked when row wise search triggered.
   * @param {any} event
   * @memberOf LocoStatusDataComponent
   */
  public searchClickEventEmit(event) {
    this.loadDataFromService(false, '', event);
  }

  /**
   * Remove loco status row event.
   * @param {any} event
   * @memberOf LocoStatusDataComponent
   */
  public removeLocoEmit(event) {
    if (event !== -1) {
      if (this.locoStatusArr) {
        const locoStatusArr = _.filter(this.locoStatusArr, function (locoStatus) {
          return locoStatus.isLocoSelected;
        });
        const cancelLocoStatusArr = [];
        for (let i = 0; i < this.locoStatusArr.length; i++) {
          if (this.locoStatusArr[i] && this.locoStatusArr[i].isLocoSelected && this.appUtilityService.isPlannedLoco(this.locoStatusArr[i])) {
            cancelLocoStatusArr.push(this.locoStatusArr[i]);
          }
        }
        if (locoStatusArr && locoStatusArr.length > 0) {
          this.isSelectedLocos = true;
        } else {
          this.isSelectedLocos = false;
        }
        if (cancelLocoStatusArr && cancelLocoStatusArr.length > 0) {
          this.isShowCancelLocoPlan = true;
        } else {
          this.isShowCancelLocoPlan = false;
        }
      }
      this.updateDataStore();
    }
  }

  /**
   * Reset page mode when popup hide.
   * @memberOf LocoStatusDataComponent
   */
  public resetPageMode() {
    this.selectedLocoStatusArr = [];
    this.ruleException = false;
    this.popUpErrorMessage = '';
    this.planOrSetCurrentAssignment = false;
    this.selectedPlan = 'Train';
    this.resetPopupErrors();
    this.planTrainId = '';
    this.thpPlanLoco = 'S';
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
  }

  /**
   * Set page mode when dialog show.
   * @param {string} btnId
   * @param {string} [dialogId]
   * @memberof LocoStatusDataComponent
   */
  setPageModeData(btnId: string, dialogId?: string) {
    if (btnId && btnId.length > 0) {
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId(btnId);
      setTimeout(() => {
        this.appUtilityService.setFocusToFirstElement(dialogId);
      }, 20);
    } else {
      this.popupService.setPageMode('');
      this.popupService.setSubmitBtnId('');
    }
  }

  /**
   * Reset popup errors when popup hide.
   * @private
   * @memberOf LocoStatusDataComponent
   */
  private resetPopupErrors() {
    this.errorDialog = false;
    this.isAddTrainError = false;
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
  }

  /**
   * Open plan or set current assignment popup.
   * @param {any} value
   * @memberOf LocoStatusDataComponent
   */
  public openPlanOrCurrentAssignmentPopup(value) {
    this.selectedLocoStatusArr = [];
    this.resetPopupErrors();
    this.planTrainId = '';
    this.selectedPlan = 'Train';
    this.thpPlanLoco = 'S';
    if ('planLocomotive' === value) {
      this.popUpErrorMessage = 'Plan Locomotive';
      this.getLocoIncident();
      this.setCurrentAssignment = false;

    } else if ('setCurrentAssignment' === value) {
      this.popUpErrorMessage = 'Set Current Assignment';
      this.setCurrentAssignment = true;
      this.planLocomotive = false;
      this.planOrSetCurrentAssignment = true;
      setTimeout(() => {
        if (this.selectedPlan && this.selectedPlan !== 'Train') {
          this.setFocusToGivenElement('locoStatusPlanTerminalSearchBox');
        } else if (this.selectedPlan && this.selectedPlan === 'Train') {
          this.setFocusToGivenElement('locoStatusPlanTrainInput');
        }
      }, 20);
    }
    const locoStArr = JSON.parse(JSON.stringify(this.locoStatusArr));
    this.selectedLocoStatusArr = locoStArr.filter((locoStatus) => {
      return locoStatus.isLocoSelected;
    });
  }

  /**
   * Open cancel locomotive plan popup.
   * @returns
   * @memberOf LocoStatusDataComponent
   */
  public openCancelLocomotivePlanPopup() {
    this.selectedLocoStatusArr = [];
    for (let i = 0; i < this.locoStatusArr.length; i++) {
      if (this.locoStatusArr[i] && this.appUtilityService.isPlannedLoco(this.locoStatusArr[i])) {
        this.selectedLocoStatusArr.push(this.locoStatusArr[i]);
      }
    }

    if (this.selectedLocoStatusArr && this.selectedLocoStatusArr.length > 0) {
      const locos = [];

      for (let i = 0; i < this.selectedLocoStatusArr.length; i++) {
        const select = {
          rowID: '',
          locomotiveID: this.appUtilityService.formatLocomotiveId(this.selectedLocoStatusArr[i].locomotiveIdentifier),
          assignedPlannedFlag: this.selectedLocoStatusArr[i].assignedPlannedFlag,
          qualifier: this.selectedLocoStatusArr[i].qualifier
        };
        locos.push(select);
      }

      const request = {
        otherLocosList: locos
      };
      const operation = {
        operation: 'CancelLocomotivePlan',
        data: request,
        currentTerminal: '      ',
        windowCode: 'LWLS'
      };
      this.popupService.setPopupOperation(operation);
    } else {
      return;
    }
  }

  /**
   * Hide plan or set current assignment popup.
   * @memberOf LocoStatusDataComponent
   */
  public hidePlanOrSetCurrentAssignmentPopup() {
    this.selectedPlan = 'Train';
    this.planOrSetCurrentAssignment = false;
  }

  /**
   * Change plan option.
   * @memberOf LocoStatusDataComponent
   */
  public changePlanOptions() {
    this.searchPlanTextTerminal = '';
    this.selectedTerminalRoad = '';
    this.selectedRoadValues = [];
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
    this.isAddTrainError = false;
    this.planTrainId = '';
    this.thpPlanLoco = 'S';
    this.isValidThpSelection = false;
    this.errorDialog = false;
    if (this.planLocomotive) {
      this.popUpErrorMessage = 'Plan Locomotive';
    } else if (this.setCurrentAssignment) {
      this.popUpErrorMessage = 'Set Current Assignment';
    } else {
      this.popUpErrorMessage = '';
    }

    setTimeout(() => {
      if (this.selectedPlan && this.selectedPlan !== 'Train') {
        this.setFocusToGivenElement('locoStatusPlanTerminalSearchBox');
      } else if (this.selectedPlan && this.selectedPlan === 'Train') {
        this.setFocusToGivenElement('locoStatusPlanTrainInput');
      }
    }, 20);
  }

  /**
   * Autocomplete for terminal mnemonic.
   * @param {any} event
   * @memberOf LocoStatusDataComponent
   */
  public autoCompleteForTerminal(event) {
    this.mnemonics = [];
    this.mileposts = [];
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          this.mnemonics.push(data[key]);
          this.mileposts.push(key);
        }
      }
    }
    this.filteredResults = this.mnemonics.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    });

    Array.prototype.push.apply(this.filteredResults, (this.mileposts.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    })));
    this.filteredResults = this.filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    this.filteredResults.sort();
  }


  /**
   * Select terminal mnemonic from autocomplete.
   * @param {string} value
   * @param {string} type
   * @memberOf LocoStatusDataComponent
   */
  public selectValueFromAutoComplete(value: string, type: string) {
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
    this.selectedTerminalRoad = '';

    let emitValue = value;
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    if (this.roadValues) {
      this.selectedRoadValues = [];
      const filteredRoadValues: Array<TerminalRoad> = this.roadValues.filter((terminalRoad) => {
        return terminalRoad.terminal === emitValue;
      });
      // if (filteredRoadValues && filteredRoadValues.length > 0) {
      //   this.selectedRoadValues.push({
      //     label: 'Select',
      //     value: 'Select'
      //   });
      // }
      for (const filteredRoadValue of filteredRoadValues) {
        this.selectedRoadValues.push({
          label: filteredRoadValue.road,
          value: filteredRoadValue.road
        });
        // if (this.selectedRoadValues && this.selectedRoadValues.length > 0) {
        //   this.selectedTerminalRoad = this.selectedRoadValues[0].value;
        // }
      }
      if (this.selectedPlan === 'Foreign Railroad') {
        if (!filteredRoadValues || (filteredRoadValues && filteredRoadValues.length <= 0)) {
          this.errorDialog = true;
          this.popUpErrorMessage = this.configData.messages.planInvalidInterchangeRoad;
        } else {
          if (this.planLocomotive) {
            this.popUpErrorMessage = 'Plan Locomotive';
          } else if (this.setCurrentAssignment) {
            this.popUpErrorMessage = 'Set Current Assignment';
          }
          this.resetPopupErrors();
        }
      }
    }
    if ('terminalPlanSuggestSearch' === type) {
      this.searchPlanTextTerminal = emitValue;
    }
    if (this.planOrSetCurrentAssignment && !this.appUtilityService.isValidThpSelection(this.searchPlanTextTerminal)) {
      this.thpPlanLoco = 'M';
      this.isValidThpSelection = true;
    } else {
      this.thpPlanLoco = 'S';
      this.isValidThpSelection = false;
    }
  }

  /**
   * Submit plan or set current assignment.
   * @memberOf LocoStatusComponent
   */
  public submitPlanOrCurrentAssignment() {
    this.lmsLoaderService.showLoader();
    if (this.selectedPlan === 'Foreign Railroad') {
      this.transferToForeignRailRoad();

    } else if (this.selectedPlan === 'Terminal') {
      this.transferToTerminal();

    } else if (this.selectedPlan === 'Train') {
      this.transferToTrain();

    }
  }

  checkForTerminalRoadValidity() {
    if (typeof  this.selectedTerminalRoad !== 'object') {
      const selectedObj = this.filteredRoadValuesObj.filter(item => {
        return item.value.toLowerCase() === this.selectedTerminalRoad.toLowerCase();
      });
      if (selectedObj.length) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  /**
   * Transfer to foreign railroad implemention.
   * @memberof LocoStatusDataComponent
   */
  transferToForeignRailRoad() {
    if (this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal) && (this.selectedTerminalRoad && '' !== this.selectedTerminalRoad && this.checkForTerminalRoadValidity())) {
      if (this.planLocomotive) {
        this.submitTransferToForeignRailRoad('XROD');
      } else if (this.setCurrentAssignment) {
        this.submitTransferToForeignRailRoad('SROD');
      }
    } else {
      this.lmsLoaderService.hideLoader();
      if (!this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal)) {
        this.searchPlanTextTerminalError = true;
        this.selectedRoadValues = [];
        this.selectedTerminalRoad = '';
      } else {
        this.searchPlanTextTerminalError = false;
      }
      if (!this.selectedTerminalRoad || '' === this.selectedTerminalRoad || !this.checkForTerminalRoadValidity()) {
        this.selectedTerminalRoadError = true;
      } else {
        this.selectedTerminalRoadError = false;
      }
    }
  }

  /**
   * Transfer to Terminal implemention.
   * @memberof LocoStatusDataComponent
   */
  transferToTerminal() {
    this.commonopsPicklist = this.appUtilityService.validateCommonPickList(this.commonopsPicklist);
    if (this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal)) {
      if (this.thpPlanLoco && this.thpPlanLoco.trim().toUpperCase() === 'S') {
        if (this.planLocomotive) {
          if (this.appUtilityService.isValidThpSelection(this.searchPlanTextTerminal)) {
            this.submitTransferToTerminal('XSTA');
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popUpErrorMessage = this.configData.messages.invalidThpSelection;
          }
        } else if (this.setCurrentAssignment) {
          this.submitTransferToTerminal('SSTA');
        }
      } else {
        if (this.planLocomotive) {
          this.submitTransferToTerminal('XSTA');
        } else if (this.setCurrentAssignment) {
          this.submitTransferToTerminal('SSTA');
        }
      }
    } else {
      this.lmsLoaderService.hideLoader();
      this.searchPlanTextTerminalError = true;
    }
  }

  /**
   * Transfer to train implementation.
   * @memberof LocoStatusDataComponent
   */
  transferToTrain() {
    if (this.appUtilityService.isValidTrainId(this.planTrainId)) {
      let isNoteError = false;
      for (let p = 0; p < this.selectedLocoStatusArr.length; p++) {
        if (this.selectedLocoStatusArr[p] && this.selectedLocoStatusArr[p].intendedUsgaeNoteRequired &&
          (!this.selectedLocoStatusArr[p].intendedUsageNote || (this.selectedLocoStatusArr[p].intendedUsageNote && this.selectedLocoStatusArr[p].intendedUsageNote.length === 0))) {
          this.selectedLocoStatusArr[p].isIntendedUsageNotError = true;
          isNoteError = true;
        } else {
          if (this.selectedLocoStatusArr[p].intendedUsageNote) {
            this.selectedLocoStatusArr[p].intendedUsageNote = this.selectedLocoStatusArr[p].intendedUsageNote.trim().toUpperCase();
          }
          this.selectedLocoStatusArr[p].isIntendedUsageNotError = false;
        }
      }
      if (!isNoteError) {
        this.serviceCallToBre(this.planTrainId, this.selectedLocoStatusArr);
        this.isAddTrainError = false;
      } else {
        this.lmsLoaderService.hideLoader();
      }

    } else {
      this.lmsLoaderService.hideLoader();
      this.isAddTrainError = true;
    }
  }

  /**
   * Invoked for transfer and set current assignment to foreign railroad.
   * XROD -> Plan Locomotive
   * SROD -> Set Current Assignment
   * @param {string} functionCode
   * @memberOf LocoStatusComponent
   */
  public submitTransferToForeignRailRoad(functionCode: string) {
    const locoTransfer: Array<LocoTransfer> = [];
    this.createLocoTransferListForForeignRoad(locoTransfer, this.searchPlanTextTerminal, ' ', this.selectedTerminalRoad);
    this.serviceCallLocoTransfer(locoTransfer, functionCode);
  }
  /**
    * Invoked for transfer and set current assignment to terminal.
    * XROD -> Plan Locomotive
    * SROD -> Set Current Assignment
    * @param {string} functionCode
    * @memberOf LocoStatusComponent
    */
  submitTransferToTerminal(functionCode: string) {
    const locoTransfer: Array<LocoTransfer> = [];
    const planType = this.setCurrentAssignment ? 'M' : this.thpPlanLoco;
    this.createLocoTransferListForTerminal(locoTransfer, this.searchPlanTextTerminal, planType);
    this.serviceCallLocoTransfer(locoTransfer, functionCode);
  }

  /**
   * Build Request Parameter for plan and set current assignment service  to foreign railroad.
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} terminal
   * @param {string} terminalType
   * @param {string} road
   * @memberOf LocoStatusComponent
   */
  createLocoTransferListForForeignRoad(locoTransfer: Array<LocoTransfer>, terminal: string, terminalType: string, road: string) {
    for (let i = 0; i < this.selectedLocoStatusArr.length; i++) {
      const locoDetail: LocoDetail = this.selectedLocoStatusArr[i];
      const a = {
        currentTerminalIdentifier: locoDetail.currentTerminalId, // To be verified
        toRoadIdentifier: road['value'] === undefined ? road.toUpperCase() : road['value'].toUpperCase(),
        terminalHandlingType: terminalType,
        atStation: terminal,
        locoTransferList: {
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(locoDetail.locomotiveIdentifier),
          qualifier: locoDetail.qualifier,
          assignedOrPlanned: locoDetail.assignedPlannedFlag
        }
      };
      locoTransfer.push(a);
    }
  }
  /**
   * Build Request Parameter for plan and set current assignment service to terminal
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} terminal
   * @param {string} terminalType
   * @param {string} road
   * @memberOf LocoStatusComponent
   */
  createLocoTransferListForTerminal(locoTransfer: Array<LocoTransfer>, terminal: string, terminalType: string) {
    for (let i = 0; i < this.selectedLocoStatusArr.length; i++) {
      const locoDetail: LocoDetail = this.selectedLocoStatusArr[i];
      const a = {
        currentTerminalIdentifier: locoDetail.currentTerminalId, // To be To be verified
        terminalIdentifier: terminal,
        terminalHandlingType: terminalType,
        locoTransferList: {
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(locoDetail.locomotiveIdentifier),
          qualifier: locoDetail.qualifier,
          assignedOrPlanned: locoDetail.assignedPlannedFlag
        }
      };
      locoTransfer.push(a);
    }
  }

  /**
     * Build Request Parameter for plan and set current assignment service to train
     * @param {Array<LocoTransfer>} locoTransfer
     * @param {string} terminal
     * @param {string} terminalType
     * @param {string} road
     * @memberOf LocoStatusComponent
     */
  createLocoTransferListForTrain(locoTransfer: Array<LocoTransfer>, trainsId: string) {
    for (let i = 0; i < this.selectedLocoStatusArr.length; i++) {
      const selectedLocmotive = this.selectedLocoStatusArr[i];
      const a = {
        currentTerminalIdentifier: selectedLocmotive.currentTerminalId, // To be To be verified
        trainIdentifier: trainsId,
        terminalHandlingType: this.setCurrentAssignment ? '' : this.thpPlanLoco,
        locoTransferList: {
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
          qualifier: selectedLocmotive.qualifier,
          assignedOrPlanned: selectedLocmotive.assignedPlannedFlag,
          intendedUsageCode: selectedLocmotive.intendedUsageCode,
          intendedUsageReason: selectedLocmotive.intendedUsageReason,
          intendedUsageNotes: selectedLocmotive.intendedUsageNote
        }
      };
      locoTransfer.push(a);
    }
  }

  /**
   * Service Call for Plan Locomotive and Set Current Assignment.
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} operation
   * @memberOf LocoStatusComponent
   */
  serviceCallLocoTransfer(locoTransfer: Array<LocoTransfer>, operation: string) {
    this.locoStatusService.transferLocomotive(locoTransfer, operation).subscribe(
      (data) => {
        this.transferResponse = <BaseResponse>data;
        if (this.appUtilityService.isNumeric(this.transferResponse.header.priorityCode)) {
          const pCode = parseInt(this.transferResponse.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.loadDataFromService(true, this.transferResponse.header.messageText);
            this.hidePlanOrSetCurrentAssignmentPopup();
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popUpErrorMessage = this.transferResponse.header.messageText;
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popUpErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      });
  }


  /**
   * Service call for BRE.
   * @param {string} trainId
   * @param {Array<String>} locoId
   * @memberOf LocoStatusComponent
   */
  serviceCallToBre(trainId: string, selectedLocoStatusArr: Array<LocoDetail>) {
    const locoId: Array<String> = [];
    for (let i = 0; i < selectedLocoStatusArr.length; i++) {
      const selectedLocmotive: LocoDetail = selectedLocoStatusArr[i];
      locoId.push(this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier));
    }
    this.locoStatusService.breTransferRequest(locoId, trainId).subscribe(
      (data) => {
        const breTrasferParam: BreTransferAreaDetails = <BreTransferAreaDetails>data;
        if (breTrasferParam && breTrasferParam.priorityCode) {
          const pCode = parseInt(breTrasferParam.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            if (this.isLmsExceptionListExist(breTrasferParam)) {
              this.lmsLoaderService.hideLoader();
              this.ruleException = true;
              this.popupService.setPageMode('Dialog');
              this.popupService.setSubmitBtnId('ruleExceptionLocoData');

              const newLmsExceptionList: Array<LmsException> = [];
              for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
                const lmsException: LmsException = breTrasferParam.lmsExceptionList[i];
                const locoObj: LocoDetail = this.getLocoObjById(lmsException.locoId, selectedLocoStatusArr);
                if (locoObj) {
                  lmsException.intendedUsageDesc = this.appUtilityService.getIntendedUsageDesc(locoObj.intendedUsageCode);
                  lmsException.intendedUsageReason = this.appUtilityService.getIntendedUsageReasonDesc(locoObj.intendedUsageReason);
                  lmsException.intendedUsageNote = locoObj.intendedUsageNote;
                }
                lmsException.isSelectedLoco = false;
                newLmsExceptionList.push(lmsException);
              }
              this.lmsExceptionList = newLmsExceptionList;

              const checkedExceptionList: Array<LmsException> = this.lmsExceptionList.filter((lmsException) => {
                return lmsException.isSelectedLoco;
              });
              if (checkedExceptionList && checkedExceptionList.length > 0) {
                this.isRuleExceptionSubmitEnabled = true;
              }
            } else {
              const locoTransfer: Array<LocoTransfer> = [];
              this.createLocoTransferListForTrain(locoTransfer, trainId);
              if (this.planLocomotive) {
                this.serviceCallLocoTransfer(locoTransfer, 'XTRN');
              } else if (this.setCurrentAssignment) {
                this.serviceCallLocoTransfer(locoTransfer, 'STRN');
              }

            }
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popUpErrorMessage = breTrasferParam.messageText;
          }
        }

      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popUpErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      }
    );
  }

  /**
   * fetch locomotive object by loco identifier.
   * @param {string} locoId
   * @param {Array<LocoDetail>} locoArr
   * @returns {LocoDetail}
   * @memberof LocoStatusDataComponent
   */
  getLocoObjById(locoId: string, locoArr: Array<LocoDetail>): LocoDetail {
    for (let x = 0; x < locoArr.length; x++) {
      const oldLocoId = this.appUtilityService.UIformatLocomotiveId(locoId);
      const newLocoId = this.appUtilityService.UIformatLocomotiveId(locoArr[x].locomotiveIdentifier);
      if (oldLocoId && newLocoId && oldLocoId.trim().toUpperCase() === newLocoId.trim().toUpperCase()) {
        return locoArr[x];
      }
    }
  }
  /**
   * Load Data from service call of loco status
   * @param {boolean} isFromOtherOperation
   * @param {string} [messageText]
   * @memberOf LocoStatusComponent
   */
  loadDataFromService(isFromOtherOperation: boolean, messageText?: string, loco?: LocoDetail) {
    const locos = this.getLocosForStatusInquiry(isFromOtherOperation, loco);
    if (locos) {
      this.locoStatusService.getData(locos).subscribe((data: any) => {
        this.lmsLoaderService.hideLoader();
        if (data && data.priorityCode) {
          const pCode = parseInt(data.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.locoStatusService.load(locos);
            this.lastRefreshTime = data.refreshTime;
            const responseLocoStatusArr: Array<LocoDetail> = data.locoStatusList;
            if (this.selectedTab) {
              this.selectedTab.lastRefreshTime = this.lastRefreshTime;
              this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.loaded;
              this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].message = '';
              const date = new Date();
              this.selectedTab.description = 'Loco Status - ' + ('0' + date.getHours().toString()).slice(-2) + ':' + ('0' + date.getMinutes().toString()).slice(-2) + ':' + ('0' + date.getSeconds().toString()).slice(-2);
              this.updateTab(this.selectedTab);
            }
            this.setDataForLocoStatus(responseLocoStatusArr, isFromOtherOperation, messageText, loco);
          } else {
            if (this.selectedTab) {
              this.selectedTab.subTypeDetail.data.message = data.messageText;
              this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.error;
              this.updateTab(this.selectedTab);
            }
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        if (this.selectedTab) {
          this.selectedTab.subTypeDetail.data.message = this.appUtilityService.getHttpErroMessage(error, false);
          this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.error;
          this.updateTab(this.selectedTab);
        }
      });
    } else {
      this.lmsLoaderService.hideLoader();
    }
  }

  /**
   * Invoked when click on refresh icon on header.
   * @memberOf LocoStatusComponent
   */
  refreshbtnEvent(event) {
    if (!event || (event && event.length === 0)) {
      if (this.selectedTab) {
        this.selectedTab.subTypeDetail.data.message = this.configService.getConfigData().messages.blankLocoStatusWindow;
        this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.error;
        this.updateTab(this.selectedTab);
      }
    }
    this.lmsLoaderService.showLoader();
    this.loadDataFromService(true);
  }

  /**
   * Get locos for loco status inquiry.
   * @param {Array<LocoDetail>} locoArr
   * @returns {string}
   * @memberOf LocoStatusComponent
   */
  getLocosForStatusInquiry(isFromOtherOperation: boolean, loco?: LocoDetail): string {
    let locos = '';
    if (!loco) {
      for (let i = 0; i < this.locoStatusArr.length; i++) {
        if (this.locoStatusArr[i] && this.locoStatusArr[i].searcheLocomotiveIdentifier) {
          this.locoStatusArr[i].searcheLocomotiveIdentifier =
            this.appUtilityService.UIformatLocomotiveId(this.locoStatusArr[i].searcheLocomotiveIdentifier);
          this.locoStatusArr[i].locomotiveIdentifier = this.appUtilityService.formatLocomotiveId(this.locoStatusArr[i].searcheLocomotiveIdentifier);
        }
      }
    }
    if (isFromOtherOperation) {
      this.filteredLocoStatusArr = this.locoStatusArr.filter((locoStatus) => {
        return locoStatus.locomotiveIdentifier;
      });
    } else {
      if (loco) {
        this.filteredLocoStatusArr = [];
        this.filteredLocoStatusArr.push(loco);
      } else {
        this.filteredLocoStatusArr = this.locoStatusArr.filter((locoStatus) => {
          return !locoStatus.isLocoStatusLoaded && locoStatus.locomotiveIdentifier;
        });
      }
    }
    if (this.filteredLocoStatusArr) {
      _.forEach(this.filteredLocoStatusArr, function (locoStatus, key) {
        locos += locoStatus.locomotiveIdentifier + ',';
      });
      if (locos) {
        locos = locos.replace(/,\s*$/, '');
      }
    }
    return locos;
  }

  /**
   * Set Loco Status Response
   * @param {Array<LocoDetail>} responseLocoStatusArr
   * @param {boolean} isFromOtherOperation
   * @memberOf LocoStatusComponent
   */
  setDataForLocoStatus(responseLocoStatusArr: Array<LocoDetail>, isFromOtherOperation: boolean, messageText?: string, loco?: LocoDetail) {
    if (isFromOtherOperation) {
      _.forEach(this.locoStatusArr, function (locoStatus, key) {
        locoStatus.isLocoSelected = false;
      });
      this.isSelectedLocos = false;
      this.isShowCancelLocoPlan = false;
    }
    if (loco && loco.locomotiveIdentifier) {
      this.setDataForSingleLocoStatus(loco, responseLocoStatusArr);
    } else {
      this.setDataForMultiLocoStatus(responseLocoStatusArr, isFromOtherOperation, messageText);
    }
    if (this.locoStatusArr) {
      this.locoStatusArr = this.locoStatusArr.filter((lstatus) => {
        return (lstatus && lstatus.searcheLocomotiveIdentifier);
      });
    }
    const lStatusArr: Array<LocoDetail> = JSON.parse(JSON.stringify(this.locoStatusArr));
    this.locoStatusArr = [];
    for (let i = 0; i < lStatusArr.length; i++) {
      lStatusArr[i].index = i;
      this.locoStatusArr[i] = lStatusArr[i];
    }
    this.updateDataStore();
  }

  /**
   * Invoked when click on search icon in loco status box.
   * @param {LocoDetail} loco
   * @param {Array<LocoDetail>} responseLocoStatusArr
   * @memberof LocoStatusDataComponent
   */
  setDataForSingleLocoStatus(loco: LocoDetail, responseLocoStatusArr: Array<LocoDetail>) {
    this.locoStatusArr = this.locoStatusArr.map((locoStatus) => {
      if (locoStatus.locomotiveIdentifier === loco.locomotiveIdentifier) {
        const locoId = this.appUtilityService.formatLocomotiveId(locoStatus.locomotiveIdentifier).replace(/\s/g, '');
        const locoDetail = this.getLocoDetailObj(responseLocoStatusArr, locoId);
        if (locoDetail) {
          locoStatus = <LocoDetail>locoDetail;
          locoStatus.isLocoStatusLoaded = true;
          locoStatus.searcheLocomotiveIdentifier = this.appUtilityService.UIformatLocomotiveId(locoStatus.locomotiveIdentifier);
          locoStatus.lastReporting = locoStatus.lastReportingSource + ' : ' + locoStatus.lastReportingDateTime + '@'
            + locoStatus.lastReportingMilepost;
        } else {
          locoStatus.isLocoError = true;
          locoStatus.locoErrorMessage = this.configData.messages.noLocoStatusFound;
          if (this.selectedTab) {
            this.selectedTab.subTypeDetail.data.message = this.configService.getConfigData().messages.invalidLocomotive;
            this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.error;
            this.updateTab(this.selectedTab);
          }
        }
      }
      return locoStatus;
    });
  }
  /**
     * Invoked when double enter, refresh click etc.
     * @param {LocoDetail} loco
     * @param {Array<LocoDetail>} responseLocoStatusArr
     * @memberof LocoStatusDataComponent
     */
  setDataForMultiLocoStatus(responseLocoStatusArr: Array<LocoDetail>, isFromOtherOperation: boolean, messageText?: string) {
    this.locoStatusArr = this.locoStatusArr.map((locoStatus) => {
      var locoCountCounter = 0;
      if (locoStatus.locomotiveIdentifier) {
        if (isFromOtherOperation || !locoStatus.isLocoStatusLoaded) {
          if (this.appUtilityService.isValidLocomotiveId(locoStatus.locomotiveIdentifier)) {
            //check how many times locomotive exists
            for(var x = 0; x < responseLocoStatusArr.length; x++)
            {
                if(responseLocoStatusArr[x].locomotiveIdentifier === locoStatus.locomotiveIdentifier )
                  locoCountCounter++;
            }
            //check if loco exists more than once the mark it as duplicated
            if(locoCountCounter >= 2)
            {
                locoStatus.isLocoError = true;
                locoStatus.locoErrorMessage = this.configData.messages.locomotiveAlreadyExists;
                return locoStatus;
            }
            const locoId = this.appUtilityService.formatLocomotiveId(locoStatus.locomotiveIdentifier).replace(/\s/g, '');
            const locoDetail = this.getLocoDetailObj(responseLocoStatusArr, locoId);
            if (locoDetail) {
              locoStatus = <LocoDetail>locoDetail;
              locoStatus.isLocoStatusLoaded = true;
              locoStatus.searcheLocomotiveIdentifier = this.appUtilityService.UIformatLocomotiveId(locoStatus.locomotiveIdentifier);
              locoStatus.lastReporting = locoStatus.lastReportingSource + ' : ' + locoStatus.lastReportingDateTime + '@'
                + locoStatus.lastReportingMilepost;
              if (isFromOtherOperation && messageText) {
                this.messageHandlerService.handleMessage(<MessageDetails>({
                  type: this.configService.getConfigData().message.type.server,
                  level: this.configService.getConfigData().message.level.success,
                  target: this.configService.getConfigData().message.target.page,
                  message: messageText
                }));
              }
            } else {
              locoStatus.isLocoError = true;
              locoStatus.locoErrorMessage = this.configData.messages.noLocoStatusFound;
              if (this.selectedTab) {
                this.selectedTab.subTypeDetail.data.message = this.configService.getConfigData().messages.invalidLocomotive;
                this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.error;
                this.updateTab(this.selectedTab);
              }
            }
          } else {
            locoStatus.locoErrorMessage = this.configData.messages.invalidLocomotiveId;
            locoStatus.isLocoError = true;
          }
        }
      } else if (locoStatus.searcheLocomotiveIdentifier) {
        if (!this.appUtilityService.isValidLocomotiveId(locoStatus.searcheLocomotiveIdentifier)) {
          locoStatus.isLocoError = true;
          locoStatus.locoErrorMessage = this.configData.messages.invalidLocomotiveId;
        }
      }
      return locoStatus;
    });
  }

  /**
   * Check for LMSExceptionList through BRE.
   * @param {BreTransferAreaDetails} breTrasferParam
   * @returns {boolean}
   * @memberOf LocoStatusComponent
   */
  isLmsExceptionListExist(breTrasferParam: BreTransferAreaDetails): boolean {
    if (breTrasferParam && breTrasferParam.lmsExceptionList && breTrasferParam.lmsExceptionList.length > 0) {
      for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
        const lmsExcpetion = breTrasferParam.lmsExceptionList[i];
        if (lmsExcpetion && 'E' === lmsExcpetion.tripPlamCompExcptnInd) {
          return true;
        }
        if (lmsExcpetion && 'Y' === lmsExcpetion.unschdQShopExcptnInd) {
          return true;
        }
        if (lmsExcpetion && lmsExcpetion.exceptionMessage && lmsExcpetion.exceptionMessage.length > 0) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Cancel Rule Exception Popup.
   * @memberOf LocoStatusComponent
   */
  cancelRuleException() {
    this.ruleException = false;
    this.planOrSetCurrentAssignment = true;
    if (this.planLocomotive) {
      this.popUpErrorMessage = 'Plan Locomotive';
    } else if (this.setCurrentAssignment) {
      this.popUpErrorMessage = 'Set Current Assignment';
    }
    this.isRuleExceptionSubmitEnabled = false;
  }

  /**
   * Reset rule exception popup.
   * @memberof LocoStatusDataComponent
   */
  resetRuleException() {
    this.ruleException = false;
    this.isRuleExceptionSubmitEnabled = false;
  }

  /**
   * Submit Rule Exception Popup.
   * @param {string} type
   * @memberOf LocoStatusComponent
   */
  public ruleExceptionSubmit() {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    const locoTransfer: Array<LocoTransfer> = [];
    for (let j = 0; j < this.selectedLocoStatusArr.length; j++) {
      const selectedLocmotive = this.selectedLocoStatusArr[j];
      for (let i = 0; i < this.lmsExceptionList.length; i++) {
        const lmsException: LmsException = this.lmsExceptionList[i];
        if (lmsException.isSelectedLoco) {
          let isException = false;
          if (lmsException.tripPlamCompExcptnInd && lmsException.tripPlamCompExcptnInd === 'E') {
            if (!lmsException.tripPlanOverrideCode) {
              this.lmsExceptionList[i].isLmsExceptionInAddReason = true;
              isException = true;
            } else {
              this.lmsExceptionList[i].isLmsExceptionInAddReason = false;
            }
          }
          if (lmsException.unschdQShopExcptnInd && lmsException.unschdQShopExcptnInd === 'Y') {
            if (!lmsException.unscheduledQShop) {
              this.lmsExceptionList[i].isLmsExceptionInAddQShop = true;
              isException = true;
            } else {
              this.lmsExceptionList[i].isLmsExceptionInAddQShop = false;
            }
          }
          if (!isException) {
            if (this.appUtilityService.formatLocomotiveId(lmsException.locoId).replace('    ', '') ===
              this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier).replace('    ', '')) {
              const a = {
                currentTerminalIdentifier: selectedLocmotive.currentTerminalId,
                terminalHandlingType: this.thpPlanLoco,
                trainIdentifier: this.planTrainId,
                locoTransferList: {
                  locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
                  qualifier: selectedLocmotive.qualifier,
                  assignedOrPlanned: selectedLocmotive.assignedPlannedFlag,
                  tripPlanCompIndicator: lmsException.tripPlamCompExcptnInd,
                  tripPlanTrainIdentifier: lmsException.tripPlanTrnId,
                  tripPlanOverrideCode: lmsException.tripPlanOverrideCode,
                  tripPlanOverrideReason: lmsException.tripPlanOverrideReason,
                  unscheduledQShop: lmsException.unscheduledQShop,
                  unscheduledQShopDate: lmsException.unscheduledQShopDate,
                  intendedUsageCode: selectedLocmotive.intendedUsageCode,
                  intendedUsageReason: selectedLocmotive.intendedUsageReason,
                  intendedUsageNotes: selectedLocmotive.intendedUsageNote
                }
              };
              locoTransfer.push(a);
            }
          }
        }
      }
    }
    if (locoTransfer && locoTransfer.length > 0) {
      this.ruleException = false;
      this.planOrSetCurrentAssignment = true;
      if (this.planLocomotive) {
        this.popUpErrorMessage = 'Plan Locomotive';
        this.serviceCallLocoTransfer(locoTransfer, 'XTRN');
      } else if (this.setCurrentAssignment) {
        this.popUpErrorMessage = 'Set Current Assignment';
        this.serviceCallLocoTransfer(locoTransfer, 'STRN');
      }
    }
  }

  /**
   * Shows locoMotive Context MEnu
   * @param {any} event
   * @memberOf LocoStatusComponent
   */
  public showLocomotiveContextMenu(event) {
    this.hideContextMenuChild();
    setTimeout(() => {
      this.selectedLoco = event;
      this.selectedLocoId = 'loco' + this.selectedLoco.locomotiveIdentifier + this.selectedLoco.index;
      this.selectedLoco.renderContextMenu = true;
    }, 5);
  }

  /**
    * this method is used to hide the context panel of locomotive
    * which comes in open state when user right click on locomotive
    * svg icon
    * @memberOf LocoStatusComponent
    */
  @HostListener('document:click') hideContextMenuChild() {
    this.hideContextMenu('host');
  }

  /**
  * this method is used to hide the context panel of locomotive/train
  * which comes in open state when user right click on locomotive/train
  * svg icon
  * @memberOf LocoStatusComponent
  */
  hideContextMenu(msg: string) {
    this.selectedLoco = null;
    this.selectedLocoId = null;
  }

  /**
   * Get loco detail object from response.
   * @param {Array<LocoDetail>} responseLocoStatusArr
   * @param {string} locoId
   * @returns {LocoDetail}
   * @memberOf LocoStatusDataComponent
   */
  getLocoDetailObj(responseLocoStatusArr: Array<LocoDetail>, locoId: string): LocoDetail {
    let loco: LocoDetail;
    if (locoId) {
      for (let i = 0; i < responseLocoStatusArr.length; i++) {
        if (responseLocoStatusArr[i] && (responseLocoStatusArr[i].validationFlag !== 'C' && responseLocoStatusArr[i].validationFlag !== 'H') &&
          responseLocoStatusArr[i].locomotiveIdentifier &&
          this.appUtilityService.formatLocomotiveId(responseLocoStatusArr[i].locomotiveIdentifier.toUpperCase()) ===
          this.appUtilityService.formatLocomotiveId(locoId.toUpperCase())) {
          loco = responseLocoStatusArr[i];
        }
      }
    }
    return loco;
  }

  /**
   * Update data store with loco status data
   * @memberOf LocoStatusDataComponent
   */
  public updateDataStore() {
    setTimeout(() => {

      if (this.selectedTab) {
        this.dataStoreService.removeTab(this.selectedTab);

        const tabData = <TabData>({
          id: this.selectedTab.id,
          subType: this.selectedTab.subType
        });
        tabData.data = tabData.data ? tabData.data : {};
        const locoStatusData = {
          locoStatusArr: this.locoStatusArr,
          lastRefreshTime: this.lastRefreshTime
        };
        tabData.data[this.selectedTab.subType] = locoStatusData;
        this.dataStoreService.putValue(this.selectedTab, tabData);
      }
    }, 50);
  }

  /**
   * Search override to parent component.
   * @memberof LocoStatusDataComponent
   */
  search() {
    let loadedLocoStatusArr = [];
    this.locoStatusArr = [];
    this.lmsLoaderService.hideLoader();
    if (this.selectedTab && this.dataStoreService.getValue(this.selectedTab)) {
      const arr: any = [];
      const length = Array<LocoDetail>(this.dataStoreService.getValue(this.selectedTab).data.Data).length;
      for (let i = 0; i < length; i++) {
        arr.push(Array<LocoDetail>(this.dataStoreService.getValue(this.selectedTab).data.Data)[i]);
      }
      if (arr && arr[0]) {
        this.locoStatusArr = arr[0].locoStatusArr;
        this.lastRefreshTime = arr[0].lastRefreshTime;
      }
    }
    if (!this.locoStatusArr) {
      this.locoStatusArr = [];
    } else {
      loadedLocoStatusArr = this.locoStatusArr.filter((locoStatus) => {
        return locoStatus.isLocoStatusLoaded;
      });
    }
    if (this.locoStatusArr && (this.locoStatusArr.length === 0) || (loadedLocoStatusArr && loadedLocoStatusArr.length === this.locoStatusArr.length)) {
      this.locoStatusArr.push({});
    }
    this.locoSelecttionEVent();
    if (this.selectedTab.subTypeDetail.data.status === 'refresh' && loadedLocoStatusArr.length !== 0) {
      this.loadDataFromService(true);
    }
  }
  /**
   * Check for duplicate loco status row.
   * @param {any} myArr
   * @param {any} prop
   * @returns
   * @memberOf LocoStatusDataComponent
   */
  removeDuplicates(myArr, prop) {
    return _.uniqBy(myArr, prop);
  }

  /**
   * Invoked when checked or un-unchecked loco from bre exception window.
   *
   * @param {any} event
   *
   * @memberOf LocoStatusDataComponent
   */
  checkCheckedLoco(event) {
    const checkedExceptionList: Array<LmsException> = this.lmsExceptionList.filter((lmsException) => {
      return lmsException.isSelectedLoco;
    });
    if (checkedExceptionList && checkedExceptionList.length > 0) {
      this.isRuleExceptionSubmitEnabled = true;
    } else {
      this.isRuleExceptionSubmitEnabled = false;
    }
  }

  /**
   * Clear error message.
   * @param {any} event
   * @memberOf LocoStatusDataComponent
   */
  clearErrorMessage(event) {
    if (this.selectedTab && this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.data && this.selectedTab.subTypeDetail.data.message) {
      this.selectedTab.subTypeDetail.data.message = '';
      this.updateTab(this.selectedTab);
    }
  }

  /**
   * Check success operation from locomotive cancel plan.
   * @private
   * @param {string} message
   * @memberof LocoStatusDataComponent
   */
  private checkSuccessOperation(message: string) {
    this.lmsLoaderService.showLoader();
    this.loadDataFromService(true, message);
  }

  public setFocusToGivenElement(inputId: string, timeOut?: string) {
    if (inputId && inputId.length > 0) {
      if (!timeOut) {
        const input = document.getElementById(inputId);
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 20);
        }
      }
      if (timeOut) {
        setTimeout(() => {
          const input = document.getElementById(inputId);
          if (input) {
            input.focus();
          }
        }, 20);
      }
    }
  }

  /**
   * Destroy the state of lifecycle hook.
   * @memberof LocoStatusDataComponent
   */
  ngOnDestroy() {
    this.popUpServiceSubscription.unsubscribe();
    if (this.tabStoreSubscription) {
      this.tabStoreSubscription.unsubscribe();
    }
    super.destroy();
  }

  getLocoIncident() {
    const locoStArr = JSON.parse(JSON.stringify(this.locoStatusArr));
    this.selectedLocoStatusArr = locoStArr.filter((locoStatus) => {
      return locoStatus.isLocoSelected;
    });
    setTimeout(() => {
      if (this.selectedLocoStatusArr) {
        for (let i = 0; i < this.selectedLocoStatusArr.length; i++) {
          const locoData: LocoDetail = this.selectedLocoStatusArr[i];
          if (locoData) {
            if (locoData.deadFlag && locoData.deadFlag.trim().toUpperCase() === 'Y') {
              locoData.locoIncident = 'OOS';

            } else if (locoData.trfIncidentS && locoData.trfIncidentS.trim().toUpperCase() === 'Y') {
              locoData.locoIncident = 'TRF';

            } else if (locoData.axles && locoData.axles.trim() === '4') {
              locoData.locoIncident = '4-ax';

            } else if (!locoData.axles || (locoData.axles && (locoData.axles.trim().length === 0 || locoData.axles.trim() === '6'))) {
              locoData.locoIncident = '6-ax';

            }
          }
        }
      }
      this.planLocomotive = true;
      this.planOrSetCurrentAssignment = true;
      if (this.selectedPlan && this.selectedPlan !== 'Train') {
        this.setFocusToGivenElement('locoStatusPlanTerminalSearchBox');
      } else if (this.selectedPlan && this.selectedPlan === 'Train') {
        this.setFocusToGivenElement('locoStatusPlanTrainInput');
      }
    }, 50);
  }

  allocateDellocateEvent(type) {
    const locoStArr = JSON.parse(JSON.stringify(this.locoStatusArr));
    this.selectedLocoStatusArr = locoStArr.filter((locoStatus) => {
      return locoStatus.isLocoSelected;
    });
    if (type && (type == 'allocate')) {
      const operation = {
        operation: 'AllocateLocomotives',
        data: this.selectedLocoStatusArr,
        windowCode: 'LWLS'
      };
      this.popupService.setPopupOperation(operation);
    } else if (type && (type == 'deallocate')) {
      const operation = {
        operation: 'DeallocateLocomotives',
        data: this.selectedLocoStatusArr,
        windowCode: 'LWLS'
      };
      this.popupService.setPopupOperation(operation);
    }
  }
}
